import React from 'react'
import { Row, Col, Label, ModalBody, Input } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import LoadingIndicator from '@/components/LoadingIndicator'
import { ValidationBoundary, Validator, ValidationState } from '@/components/validation'
import { EnumDropDownList } from '@/components/enumDropDownList'
import { checkingRuleSeverity } from '@/enums/checkingRuleSeverity'
import { localized } from '@/decorators/localized'
import Resx from '@/components/Resx'
import { withPermissions } from '@/decorators/withPermissions'

@localized()
@withPermissions()
class EditCheckingRuleDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = { ...props.checkingRule }
  }

  canManage () { return this.props.isGranted('CanManageCheckingRules') }
  renderBody () {
    if (this.props.loading) { return <LoadingIndicator /> }
    const disabled = !this.canManage()
    return (
      <React.Fragment>
        <Row>
          <Col lg='6'>
            <Label><Resx name='Reporting.Severity' /></Label>
            <EnumDropDownList disabled={disabled} enumDefinition={checkingRuleSeverity} value={this.state.severity} onChange={e => this.setState({ severity: e.value })} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Label><Resx name='Reporting.Expression' /></Label>
            <Validator name='expression' value={this.state.expression} required>
              <Input disabled={disabled} value={this.state.expression} onChange={e => this.setState({ expression: e.target.value })} />
            </Validator>
          </Col>
        </Row>
        <Row>
          <Col>
            <Label><Resx name='Reporting.LatinMessage' /></Label>
            <Input disabled={disabled} value={this.state.latinMessage || ''} onChange={e => this.setState({ latinMessage: e.target.value })} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Label><Resx name='Reporting.Message' /></Label>
            <Input disabled={disabled} value={this.state.message || ''} onChange={e => this.setState({ message: e.target.value })} />
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  render () {
    const { loading, updating, disabled } = this.props
    const isDisabled = loading || updating || !this.canManage()
    return (
      <ValidationBoundary>
        <BasicHeader title='' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            {this.renderBody()}
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...this.props} onAction={() => this.props.onAction(this.state)} disabled={isDisabled || !isValid || disabled} />
        } />
      </ValidationBoundary>
    )
  }
}

export {
  EditCheckingRuleDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/editCheckingRule/dialog.js